module.exports = __webpack_public_path__ + "img/10D.39ef422e.png";